import gql from 'graphql-tag';
import { lightUserFragment } from './light-user.fragment';

export const groupMemberFragment = gql`
  fragment groupMemberFragment on GroupMember {
    membershipID
    level
    reputation
    membershipStatus
    userData {
      ...lightUserFragment
    }
  }
  ${lightUserFragment}
`;
